<template>
  <TContainer :mobile-full="true">
    <UCarousel v-slot="{ item }" :items="items" :ui="cottageCarousel">
      <UCard
        as="a"
        :ui="carouselCardFourWithoutBorder"
        :href="item.url"
        @click="emit('button-click', $event)"
      >
        <TLazyimg
          :src="item.src"
          alt=""
          :classes-img="cardLazyImgRounded"
          classes="aspect-w-3 aspect-h-2"
        />
        <UBadge
          class="absolute top-2 left-2 text-ellipsis line-clamp-1 mr-2 break-all"
          color="error"
          variant="solid"
          size="md"
        >
          {{ item.discountPercent }}
        </UBadge>
        <template #footer>
          <div class="min-h-6 mb-0">
            <TText
              v-if="item.title"
              variant="semibold"
              clamp="clamp1"
              classes="mb-0"
            >
              {{ item.title }}
            </TText>
          </div>
          <TText color="text-gray-600" classes="mb-0">
            {{ item.subtitle }}
          </TText>
          <TText size="sm" classes="mb-0">
            {{ item.nights }}
          </TText>
          <TText size="sm" classes="mb-0">
            {{ item.pricePersonNight }}
          </TText>
          <div class="min-h-16 mb-1">
            <TText tag="div" size="sm" clamp="clamp3" classes="text-ellipsis">
              <div v-html="item.description" />
            </TText>
          </div>
          <div>
            <TText tag="span" variant="semibold">
              {{ item.priceNew }}
            </TText>
            <TText tag="span"> {{ item.priceOld }} </TText>
          </div>
          <UButton
            color="neutral"
            variant="solid"
            tabindex="-1"
            block
            :label="item.buttonText"
            class="mt-4 group-hover:opacity-80"
          />
        </template>
      </UCard>
    </UCarousel>
  </TContainer>
</template>
<script setup lang="ts">
import { cottageCarousel } from '~~/modules/design-system/utils/nuxt-ui-config/components/carousel'
import { carouselCardFourWithoutBorder } from '~~/modules/design-system/utils/nuxt-ui-config/components/card'
import { cardLazyImgRounded } from '~~/modules/design-system/components/t-lazyimg/constants/config'

export interface propsInterface {
  items: {
    url: string
    src: string
    discountPercent: string
    title?: string | null
    subtitle: string
    description: string
    nights: string
    pricePersonNight: string
    priceNew: string
    priceOld: string
    buttonText: string
  }[]
}

defineProps<propsInterface>()

const emit = defineEmits(['button-click'])
</script>
